import React from 'react';
import { motion } from 'framer-motion';
import { fadeIn } from '../../utils/animations';
import Card from './Card';
import { FaArrowRight } from 'react-icons/fa';

const ServiceCard = ({ icon: Icon, title, description, link = '#', className = '' }) => {
  return (
    <motion.div {...fadeIn}>
      <Card className={`group ${className}`}>
        <div className="mb-4">
          <div className="w-14 h-14 rounded-lg bg-gradient-primary flex items-center justify-center">
            <Icon className="text-white text-2xl" />
          </div>
        </div>
        <h3 className="text-xl font-bold mb-3 text-gray-900 group-hover:text-primary-blue transition-colors">
          {title}
        </h3>
        <p className="text-gray-600 mb-4 leading-relaxed">{description}</p>
        <a
          href={link}
          className="inline-flex items-center text-primary-blue font-semibold hover:text-primary-purple transition-colors"
        >
          Learn More
          <FaArrowRight className="ml-2 group-hover:translate-x-1 transition-transform" />
        </a>
      </Card>
    </motion.div>
  );
};

export default ServiceCard;
